// Function to parse text into first name, last name, email, address, city, state, postal code for multiple lines
export const parseCustomersFromInput = (text) => { // Function to parse text into first name, last name, email, address, city, state, postal code, and phone number for multiple lines
  const lines = text.trim().split('\n');
  const results = [];

  // Skip the header (first line)
  for (let i in lines) {
    const fields = lines[i].split(',');
    if (fields?.length <= 1) {
      continue;
    }
    const result = {
      firstName: fields[0]?.trim(),
      lastName: fields[1]?.trim(),
      email: fields[2]?.trim(),
      phoneNumber: fields[8]?.trim(),
      address: fields[3]?.trim(),
      city: fields[4]?.trim(),
      state: fields[6]?.trim(),         // Using StateAbbreviation (index 6)
      postalCode: fields[7]?.trim()
    };
    results.push(result);
  }

  // Return the array of results
  return results;
}

